import Vue from "vue";
import Router from "vue-router";
import Layout from "./views/Layout.vue";
import MobileDownloadPop from "./views/MobileDownloadPop.vue";

Vue.use(Router);

function lazyLoad(view) {
  return () => import(/* webpackChunkName: "view-[request]" */ `@/views/${view}.vue`);
}

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      meta: {
        requiresAuth: false,
      },
      component: Layout,
      children: [
        {
          path: "",
          name: "home",
          component: lazyLoad("Home"),
        },
        {
          path: "/about",
          name: "about",
          meta: {
            guest: true,
          },
          component: lazyLoad("About"),
        },
        {
          path: "/privacy_policy",
          name: "privacy_policy",
          meta: {
            guest: true,
          },
          component: lazyLoad("PrivacyPolicy"),
        },
        {
          path: "/gdpr_policy",
          name: "gdpr_policy",
          meta: {
            guest: true,
          },
          component: lazyLoad("GDPRPolicy"),
        },
        {
          path: "/terms_and_conditions",
          name: "terms_and_conditions",
          meta: {
            guest: true,
          },
          component: lazyLoad("TermsAndCondition"),
        },
        {
          path: "/faq",
          name: "faq",
          meta: {
            guest: true,
          },
          component: lazyLoad("Faq"),
        },
        {
          path: "/contact",
          name: "contact",
          meta: {
            guest: true,
          },
          component: lazyLoad("Contact"),
        },
        {
          path: "/pricing",
          name: "pricing",
          meta: {
            guest: true,
          },
          component: lazyLoad("Pricing"),
        },
        {
          path: "/login",
          name: "login",
          meta: {
            guest: true,
          },
          component: lazyLoad("Login"),
        },
        {
          path: "/how_it_works",
          name: "how_it_works",
          meta: {
            guest: true,
          },
          component: lazyLoad("HowItWorks"),
        },
        // {
        //   path: "/register",
        //   name: "register",
        //   meta: {
        //     guest: true,
        //   },
        //   component: lazyLoad("Register"),
        // },
        {
          path: "/verify/email",
          name: "verify_email",
          meta: {
            guest: true,
          },
          component: lazyLoad("VerifyEmail"),
        },
        {
          path: "/verify/transfer",
          name: "verify_transfer",
          meta: {
            guest: true,
          },
          component: lazyLoad("VerifyTransfer"),
        },
        {
          path: "/reset/password",
          name: "reset_password",
          meta: {
            guest: true,
          },
          component: lazyLoad("ResetPassword"),
        },
        {
          path: "/ebook",
          name: "download_ebook",
          meta: {
            guest: true,
          },
          component: lazyLoad("EbookForm"),
        },
        {
          path: "/blog",
          meta: {
            requiresAuth: false,
          },
          component: lazyLoad("blog/Blog"),
          children: [
            {
              path: "",
              name: "blog.home",
              component: lazyLoad("blog/BlogHome"),
            },
            {
              path: "/blog/:seo_title/:reference",
              name: "blog.details",
              component: lazyLoad("BlogDetails"),
            },
            {
              path: "/blog/brasileirosnoexterior",
              name: "blog.details1",
              component: lazyLoad("blog/dummy_posts/post_1"),
            },
            {
              path: "/blog/comoenviardinheiroparaobrasil",
              name: "blog.details2",
              component: lazyLoad("blog/dummy_posts/post_2"),
            },
            {
              path: "/blog/zonasepa-transferenciasparaobrasil",
              name: "blog.details3",
              component: lazyLoad("blog/dummy_posts/post_3"),
            },
            {
              path: "/blog/tiposdeboletosefraudes",
              name: "blog.details4",
              component: lazyLoad("blog/dummy_posts/post_4"),
            },
            {
              path: "/blog/a-lei-geral-de-protecao-de-dados",
              name: "blog.details5",
              component: lazyLoad("blog/dummy_posts/post_5"),
            },
            {
              path: "/blog/cambio-variacao-cambial",
              name: "blog.details6",
              component: lazyLoad("blog/dummy_posts/post_6"),
            },
            {
              path: "/blog/enviar-dinheiro-para-o-brazil",
              name: "blog.details7",
              component: lazyLoad("blog/dummy_posts/post_7"),
            },
            {
              path: "/blog/emitir-e-alterar-boleto-de-pagamento",
              name: "blog.details8",
              component: lazyLoad("blog/dummy_posts/post_8"),
            },
            {
              path: "/blog/trabalhar-na-europa-como-fazer-uma-carta-de-motivacao",
              name: "blog.details9",
              component: lazyLoad("blog/dummy_posts/post_9"),
            },
            {
              path: "/blog/carteira-de-motorista-na-europa",
              name: "blog.details10",
              component: lazyLoad("blog/dummy_posts/post_10"),
            },
            {
              path: "/blog/curriculo-europeu-entenda-como-criar-o-seu",
              name: "blog.details11",
              component: lazyLoad("blog/dummy_posts/post_11"),
            },
            {
              path: "/blog/como-conseguir-um-trabalho-na-europa",
              name: "blog.details12",
              component: lazyLoad("blog/dummy_posts/post_12"),
            },
            {
              path: "/blog/como-pagar-a-gps-estando-no-exterior",
              name: "blog.details13",
              component: lazyLoad("blog/dummy_posts/post_13"),
            },
            {
              path: "/blog/o-que-e-darf-e-como-paga-lo-fora-do-brasil",
              name: "blog.details14",
              component: lazyLoad("blog/dummy_posts/post_14"),
            },
            {
              path: "/blog/pagar-aposentadoria-na-europa-inss",
              name: "blog.details15",
              component: lazyLoad("blog/dummy_posts/post_15"),
            },
          ],
        },
      ],
    },
    {
      path: "/download/pop/:token/:transfer/:language",
      name: "MobileDownloadPop",
      meta: {
        guest: true,
        requiresAuth: false,
      },
      component: MobileDownloadPop,
    },
    {
      path: "/dashboard",
      meta: {
        requiresAuth: true,
      },
      component: lazyLoad("member/Dashboard"),
      children: [
        {
          path: "",
          name: "dashboard.home",
          component: lazyLoad("member/Home"),
        },
        {
          path: "activity",
          name: "dashboard.activity",
          component: lazyLoad("member/Activity"),
        },
        {
          path: "activity/:transfer_reference",
          name: "dashboard.activity.details",
          component: lazyLoad("member/ActivityDetails"),
        },
        // {
        //   path: "beneficiaries",
        //   name: "dashboard.beneficiaries",
        //   component: lazyLoad("member/Beneficiaries"),
        // },
        // {
        //   path: "beneficiary/add",
        //   name: "dashboard.beneficiary.add",
        //   component: lazyLoad("member/BeneficiaryAdd"),
        // },
        // {
        //   path: "beneficiary/:reference",
        //   name: "dashboard.beneficiary.details",
        //   component: lazyLoad("member/BeneficiaryDetails"),
        // },
        {
          path: "settings",
          name: "dashboard.settings",
          component: lazyLoad("member/Settings"),
        },
        {
          path: "kyc/upload",
          name: "dashboard.kyc.upload",
          component: lazyLoad("member/KYCUpload"),
        },
        {
          path: "pay_bill",
          name: "dashboard.pay_bill",
          component: lazyLoad("member/TransferBill"),
        },
        // {
        //   path: "send_money",
        //   name: "dashboard.send_money",
        //   component: lazyLoad("member/TransferMoney"),
        // },
        // {
        //   path: "send_money/:reference",
        //   name: "dashboard.send_money.reference",
        //   component: lazyLoad("member/TransferMoney"),
        // },
        // {
        //   path: "send_money/repeat/:reference",
        //   name: "dashboard.send_money.repeat.reference",
        //   component: lazyLoad("member/TransferMoneyRepeat"),
        // },
      ],
    },
  ],
});
